import React, { Component } from 'react';
import { connect } from 'react-redux';


class SearchErrorMessage extends Component { 
    render() {
        if(!this.props.loading && this.props.error) {
            return (
                <div className="row">
                    <div className="col text-center">
                        <em className="text-medium d-block p-y-md color--red">{this.props.translations.errorMessage}</em>
                    </div>
                </div>
            ); 
        }
        return null;
    }
}


function mapStateToProps(state) {
    return {
      translations: state.translations,
      loading: state.searchLoading,
      error: state.searchError
    };
  }
  
export default connect(mapStateToProps)(SearchErrorMessage);
